import { useCallback, useEffect, useState } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { useLocation } from 'react-router-dom';
import { FEATURE_FLAGS_NAMES, HTTP_OPTIONS, TOWER_MENU_ITEMS } from '@silverfort-nodelibs/common/utils/consts';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';

import Login from './components/Login/Login';
import SupportLogin from './components/SupportLogin/SupportLogin';
import './components/common/css/bootstrap-new.min.css';
import './components/common/fontawesome/css/font-awesome.css';
import './components/common/css/react-datepicker.css';
import './components/common/css/rc-time-picker.css';
import './components/common/css/UsersStyle.css';
import './components/common/css/LogsStyle.css';
import './components/common/css/AccessAnalysisStyles.css';
import './components/common/css/InvestigationStyle.css';
import './components/common/css/InsightsStyle.css';
import './components/common/css/SystemStatusStyle.css';
import './components/common/css/SoftwareUpdatesStyle.css';
import './components/common/css/NotificationsStyle.css';
import './components/common/css/DataTableStyle.css';
import './components/common/css/MainStyle.css';
import useFeature from './components/SystemSettings/hooks/featureFlags/useFeature';
import useAppcuesScript from './appcues/use-appcues';
import BaseSitePage from './routings/pages/BaseSitePage';
import SiteRoutings from './routings/SiteRoutings';
import LogoPage from './routings/pages/LogoPage';
import EulaPage from './routings/pages/EulaPage';
import SaasSupportWarningPage from './routings/pages/SaasSupportWarningPage';
import SaasSupportRestrictedRouting from './routings/SaasSupportRestrictedRouting';
import SiteContextWrapper from './context/contextWrappers/SiteContextsWrapper';
import useUpdateTabTitle from './hooks/useUpdateTabTitle';
import { useUserContext } from './context/contexts/UserContext/UserContext';
import ReactQueryDevTools from './components/DevTools/ReactQueryDevTools';
import { useSassRestrictions } from './context/contexts/SassRestrictionsContext';

const App = () => {
    const location = useLocation();

    if (location.pathname.toLowerCase() === '/login') {
        return <Login />;
    }

    if (location.pathname.toLowerCase() === '/sbmbenoagyogrhlg') {
        return <SupportLogin />;
    }

    return (
        <SiteContextWrapper>
            <AppRoutes />
            <ReactQueryDevTools />
        </SiteContextWrapper>
    );
};

const AppRoutes = () => {
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    const { restrictedSaasSupportMode, companyName, eulaAgree, setAgreeEula } = useSassRestrictions();
    const [selectedItem, setSelectedItem] = useState(TOWER_MENU_ITEMS.DASHBOARD);
    const { user } = useUserContext();

    const handleSelectedItemChange = useCallback(
        (id) => {
            setSelectedItem(id);
        },
        [setSelectedItem]
    );

    useAppcuesScript();
    useUpdateTabTitle(selectedItem);

    if (!systemMode || !user) {
        return <LogoPage />;
    }

    if (systemMode === SYSTEM_MODES.SAAS && !eulaAgree) {
        return <EulaPage setAgreeEula={setAgreeEula} />;
    }

    return (
        <BaseSitePage selectedItem={selectedItem} onSelectedItemChange={handleSelectedItemChange}>
            {systemMode === SYSTEM_MODES.SAAS_SUPPORT && <SaasSupportWarningPage companyName={companyName} />}
            {restrictedSaasSupportMode ? <SaasSupportRestrictedRouting /> : <SiteRoutings />}
        </BaseSitePage>
    );
};

export default App;
